/**
 * @flow
 * @relayHash 4b07a7a75c1cb0699af0fec71b39ee01
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CSSettledTransactionList_viewer$ref = any;
export type CSSettledTransactionListQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  search?: ?string,
  reportDate?: ?any,
  matched?: ?boolean,
  ignore?: ?boolean,
|};
export type CSSettledTransactionListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CSSettledTransactionList_viewer$ref
  |}
|};
export type CSSettledTransactionListQuery = {|
  variables: CSSettledTransactionListQueryVariables,
  response: CSSettledTransactionListQueryResponse,
|};
*/


/*
query CSSettledTransactionListQuery(
  $first: Int
  $offset: Int
  $search: String
  $reportDate: Date
  $matched: Boolean
  $ignore: Boolean
) {
  viewer {
    ...CSSettledTransactionList_viewer_1W60x4
    id
  }
}

fragment CSSettledTransactionList_viewer_1W60x4 on Query {
  clearstreamSettledTransactions(first: $first, offset: $offset, search: $search, reportDate: $reportDate, ignore: $ignore, matched: $matched, orderBy: "-createdAt") {
    edges {
      node {
        brokertransactionPtr {
          id
        }
        brokerOrder {
          id
          csbrokerorder {
            id
            transferAdviceFile {
              id
              csvUrl
              csv
            }
          }
        }
        id
        createdAt
        updatedAt
        reportDate
        matched
        ignore
        price
        yourReference
        isin
        status
        settledAmount
        proceeds
        quantity
        currency
      }
    }
    count
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "reportDate",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "matched",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "ignore",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v2 = {
  "kind": "Variable",
  "name": "ignore",
  "variableName": "ignore"
},
v3 = {
  "kind": "Variable",
  "name": "matched",
  "variableName": "matched"
},
v4 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v5 = {
  "kind": "Variable",
  "name": "reportDate",
  "variableName": "reportDate"
},
v6 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CSSettledTransactionListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CSSettledTransactionList_viewer",
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CSSettledTransactionListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "clearstreamSettledTransactions",
            "storageKey": null,
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": "-createdAt"
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "concreteType": "CSSettledTransactionNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CSSettledTransactionNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CSSettledTransactionNode",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokertransactionPtr",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerTransactionNode",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokerOrder",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerOrderNode",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "csbrokerorder",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CSBrokerOrderNode",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "transferAdviceFile",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CSCashTransferPreAdviseFileNode",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "csvUrl",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "csv",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "updatedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "reportDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "matched",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "ignore",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "price",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "yourReference",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isin",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "settledAmount",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "proceeds",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "quantity",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currency",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CSSettledTransactionListQuery",
    "id": null,
    "text": "query CSSettledTransactionListQuery(\n  $first: Int\n  $offset: Int\n  $search: String\n  $reportDate: Date\n  $matched: Boolean\n  $ignore: Boolean\n) {\n  viewer {\n    ...CSSettledTransactionList_viewer_1W60x4\n    id\n  }\n}\n\nfragment CSSettledTransactionList_viewer_1W60x4 on Query {\n  clearstreamSettledTransactions(first: $first, offset: $offset, search: $search, reportDate: $reportDate, ignore: $ignore, matched: $matched, orderBy: \"-createdAt\") {\n    edges {\n      node {\n        brokertransactionPtr {\n          id\n        }\n        brokerOrder {\n          id\n          csbrokerorder {\n            id\n            transferAdviceFile {\n              id\n              csvUrl\n              csv\n            }\n          }\n        }\n        id\n        createdAt\n        updatedAt\n        reportDate\n        matched\n        ignore\n        price\n        yourReference\n        isin\n        status\n        settledAmount\n        proceeds\n        quantity\n        currency\n      }\n    }\n    count\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e0374ad035d4488048424161487d7128';
module.exports = node;
